import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createKubernetesScopedKubeconfig } from '@api/sdk.gen';
import { KubernetesScopedKubeconfigPayload } from '@api/types.gen';

import { withError } from '@/react-tools/react-query';
import { EnvironmentId } from '@/react/portainer/environments/types';

import { queryKeys } from './query-keys';

interface CreateScopedKubeconfigParams extends KubernetesScopedKubeconfigPayload {
  environmentId: EnvironmentId;
}

export function useCreateScopedKubeconfigMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ environmentId, ...payload }: CreateScopedKubeconfigParams) =>
      create(environmentId, payload),
    onSuccess: (_data, { environmentId }) =>
      queryClient.invalidateQueries({
        queryKey: queryKeys.environment(environmentId),
      }),
    ...withError('Unable to create scoped kubeconfig'),
  });
}

async function create(
  environmentId: EnvironmentId,
  payload: KubernetesScopedKubeconfigPayload
) {
  const { data } = await createKubernetesScopedKubeconfig({
    path: { id: environmentId },
    body: payload,
  });
  return data;
}
